<template>
	<basic-container
		id="content_top"
		v-loading="isInitLoading"
		:block="isInitLoading"
		element-loading-background="rgba(245, 245, 245, 0.96)">
		<el-steps v-if="!isInitLoading" :active="currentStep * 1" align-center finish-status="success" show-icon>
			<el-step v-for="(itemData, index) in stepList" :key="index" :title="itemData"></el-step>
		</el-steps>
		<el-row justify="center" type="flex">
			<div class="u-font-xs" v-html="productName"></div>
		</el-row>
		<el-tabs v-if="!isInitLoading" v-model="currentStep" tab-position="top">
			<el-tab-pane v-loading="isPriceLoading" label="" name="0">
				<div v-if="isShowUnit">
					<!--投保企业-->
					<FormUnitNew
						ref="refUnitHolder"
						:applicantFormData="insureConfigData.applicantForm"
						:from-type="1"
						:insure-type="insureType"
						:productId="productId"
						:sourceProductId="sourceProductId"
						:totalPremium="totalPremium"
						class="u-m-b-20"
						@onChangeProductId="onChangeProductId"
						@onGoToTop="onGoToTop"
						@onNeedCalcPrice="onNeedCalcPrice"
						@onSameUnitChange="onSameUnitChange"
						@onSubmittedData="onSubmittedDataM"
						@onToChangeInsure="onToChangeInsure"></FormUnitNew>
					<!--被保企业-->
					<FormUnitNew
						v-if="!isSameUnit"
						ref="refUnitInsured"
						:applicantFormData="insureConfigData.insurantForm"
						:from-type="2"
						:insure-type="insureType"
						:productId="productId"
						:sourceProductId="sourceProductId"
						class="u-m-b-20"
						@onChangeProductId="onChangeProductId"
						@onNeedCalcPrice="onNeedCalcPrice"
						@onSubmittedData="onSubmittedDataM"
						@onToChangeInsure="onToChangeInsure"></FormUnitNew>
					<!--共同被保险人-->
					<form-unit-insured-new
						v-if="isShowGongBao"
						ref="refGongBao"
						:applicant-form-data="insureConfigData.applicantForm"
						:insure-type="insureType"
						:product-id="productId"
						:source-product-id="sourceProductId"
						class="u-m-b-20"></form-unit-insured-new>
				</div>
				<!--网点主营品牌-->
				<form-brand-new
					v-if="insureConfigData.brandIdForm && !isAdd"
					ref="refBrand"
					:brand-form-all-data="insureConfigData.brandIdForm"
					class="u-m-b-20"></form-brand-new>

				<div class="u-m-b-20" style="display: flex">
					<!--方案-->
					<FormPlanNew
						ref="refPlan"
						:dutyInfoData="insureConfigData.dutyInfo"
						:insure-type="insureType"
						:isAdd="isAdd"
						:planFormAllData="insureConfigData.planForm"
						class="u-m-r-10"
						style="flex: 1"
						@onNeedCalcPrice="onNeedCalcPrice"
						@onSubmittedData="onSubmittedDataM"></FormPlanNew>
					<FormPeriodNew
						ref="refPeriod"
						:add-price-type="addPriceType"
						:insure-type="insureType"
						:is-add="isAdd"
						:policyFormAllData="insureConfigData.orderForm"
						:product-id="productId"
						:source-product-id="sourceProductId"
						class="u-m-l-10"
						style="flex: 1"
						@onNeedCalcPrice="onNeedCalcPrice"
						@onPeriodChange="onCalcPrice"
						@onSubmittedData="onSubmittedDataM"></FormPeriodNew>
				</div>
				<!--盖章文件-->
				<FormFileConfirmNew
					v-if="!isAdd && isNeedDeclareStart"
					ref="refFiles"
					:declare-form-data="insureConfigData.declareForm"
					:insure-type="insureType"
					:is-need-declare-start="isNeedDeclareStart"
					:product-id="productId"
					:source-product-id="sourceProductId"
					@onSubmittedData="onSubmittedDataM"></FormFileConfirmNew>
				<!--投保人员-->
				<FormEmployeeNew
					ref="refEmployee"
					:act-type="actType"
					:empFormAllData="insureConfigData.empForm"
					:insure-type="insureType"
					:is-more="isMore"
					:onConfirmAllData="onConfirmAllData"
					:order-id="orderId"
					:product-id="productId"
					:source-product-id="sourceProductId"
					:total-price="totalPremium"
					:unitFormAllData="insureConfigData.applicantForm"
					class="u-m-b-20"
					@onClearAllData="onClearAllData"
					@onNeedCalcPrice="onNeedCalcPrice"
					@onSubmittedData="onSubmittedDataM"></FormEmployeeNew>

				<!--盖章文件-->
				<FormFileConfirmNew
					v-if="!isAdd && !isNeedDeclareStart"
					ref="refFiles"
					:declare-form-data="insureConfigData.declareForm"
					:insure-type="insureType"
					:is-need-declare-start="isNeedDeclareStart"
					:product-id="productId"
					:source-product-id="sourceProductId"
					@onSubmittedData="onSubmittedDataM"></FormFileConfirmNew>

				<!--附件数据 formAttach-->
				<form-attach
					v-if="insureConfigData.attachForm"
					ref="refAttach"
					:attachFormAllData="insureConfigData.attachForm"
					class="u-m-b-20"></form-attach>
				<!--发票数据 发票不需要回调数据-->
				<FormInvoiceNew
					ref="refInvoice"
					:insureType="insureType"
					:is-add="isAdd"
					:is-more="isMore"
					:product-id="productId"
					:source-product-id="sourceProductId"
					:total-premium="totalPremium"
					class="u-m-b-20"></FormInvoiceNew>
				<!--特约数据-->
				<insure-notices-new
					ref="refInsureNotices"
					:insureType="insureType"
					:is-add="isAdd"
					:is-can-scroll="isCanScroll"
					:productId="productId"
					:protocol-info-data="insureConfigData.protocolInfo"
					:sourceProductId="sourceProductId"
					@onFirstStepConfirm="onStepConfirmInsure"
					@onInsureReadOver="onInsureReadOver"></insure-notices-new>
			</el-tab-pane>
			<el-tab-pane v-loading="isPriceLoading" label="" name="1">
				<div v-loading="isInitConfirmLoading">
					<!--投保信息-->
					<ViewInfoConfirm
						ref="refInfoConfirm"
						:act-type="actType"
						:emps-data="calcAllData.empInfos"
						:is-add="isAdd"
						:is-more="isMore"
						:order-info-data="calcAllData.orderInfo"
						:total-premium="totalPremium"
						:unit-name="calcAllData.applicant.name"
						class="u-m-b-20"></ViewInfoConfirm>
					<!--开票信息-->
					<ViewInvoiceConfirm
						ref="refInvoiceConfirm"
						:insureType="insureType"
						:is-more="isMore"
						style="margin-top: 20px"></ViewInvoiceConfirm>
					<el-row class="u-m-t-20 u-m-b-20" justify="center" type="flex">
						<el-button @click="onStepEditInsure">&lt;&lt;上一步，修改保单</el-button>
						<el-button :loading="isCheckingInsure" type="primary" @click="onStepPay">下一步，去支付>></el-button>
					</el-row>
				</div>
			</el-tab-pane>
			<el-tab-pane label="" name="2">
				<template v-if="currentStep === '2'">
					<!--选择支付方式-->
					<choice-pay-type
						:insure-type="insureType"
						:is-add="isAdd"
						:is-pay-loading.sync="isPayLoading"
						:order-id="orderId"
						:pay-types-data="configSetting.payTypes || []"
						:product-id="productId"
						:source-product-id="sourceProductId"
						:total-price="totalPremium"
						class="u-m-b-20"
						@onToPay="handlePayPolicy"></choice-pay-type>
					<el-row justify="center" type="flex">
						<el-button :disabled="isPayLoading" @click="currentStep = '1'">&lt;&lt;上一步，确认保单</el-button>
					</el-row>
				</template>
			</el-tab-pane>
			<el-tab-pane label="" name="3">
				<template v-if="currentStep === '3'">
					<!--支付结果-包含对公和对私-->
					<PayResult
						:insure-type="insureType"
						:is-add="isAdd"
						:is-pay-loading.sync="isPayLoading"
						:order-id="orderId"
						:pay-source="paySource"
						:pay-types-data="configSetting.payTypes || []"
						:pre-pay-notice-data="configSetting.prePayNotice"
						:product-id="productId"
						:source-product-id="sourceProductId"
						:temp-order-id="isAdd ? endorseOrderId : orderId"
						is-close-tag
						:total-price="totalPremium"
						@onPayAgain="onOpenToPay"
						@onToPolicyDetail="onToPolicyDetail"></PayResult>
				</template>
			</el-tab-pane>
		</el-tabs>

		<!--暂存保单-->
		<FloatSaveBtn
			v-if="!isAdd"
			:loading="isAddStaging"
			text="暂存保单"
			@onFloatBtnClicked="onSaveCache()"></FloatSaveBtn>

		<el-dialog :visible.sync="isShowRepeatEmpDialog" title="提示" width="60%">
			<avue-crud
				ref="crud"
				:data="repeatEmpList"
				:option="optionRepeatEmployee"
				:table-loading="tableLoadingRepeatEmpList">
				<template slot="menuLeft">
					当前被保企业：
					<span v-if="calcAllData.applicant" class="red-bold">{{ calcAllData.applicant.name }}</span>
					<el-alert
						:closable="false"
						style="margin: 5px 0"
						title="以下投保人员已通过其他企业投保，请确认是否需要再次投保？"
						type="warning"></el-alert>
				</template>
			</avue-crud>
			<template slot="footer" class="dialog-footer">
				<el-button type="primary" @click="isShowRepeatEmpDialog = false">修改投保人员</el-button>
				<el-button @click="onInsureAgain">确认再次投保</el-button>
			</template>
		</el-dialog>
		<DialogRepeatEmps ref="repeatEmpsDlg" @removeRepeatEmps="handleRemoveRepeatEmps"></DialogRepeatEmps>
		<DialogInsureNumber
			v-if="isShowInsureNumberYet"
			ref="insureNumber"
			:visible.sync="isShowInsureNumberYet"></DialogInsureNumber>

		<InsureNotices
			ref="refInsureNoticesHint"
			@onConfirmAutoStatus="onConfirmAutoStatus"
			@onToCancel="onToCancel"
			@onToSure="onToSure"></InsureNotices>

		<BaseHintDialog
			ref="refNewerHint"
			left-btn-content="太忙了，稍后查看"
			right-btn-content="马上了解"
			title-content="操作须知"
			@onBaseDialogHint="onBaseDialogHint">
			<div slot="content">
				如何替换、加人，您知道了吗？
				<br />
				如何制作精美的投保计划书，您知道吗？
				<br />
				职业、工种的投保方案建议，您知道吗？
				<br />
				<span class="red-bold">为了更顺畅地使用本系统，提醒您尽快完成本系统的操作指引的阅读，解锁更多实用功能！</span>
			</div>
		</BaseHintDialog>
	</basic-container>
</template>

<script>
import {
	addStaging,
	endorseAdd,
	getPolicyDetails,
	getRenewData,
	getRenewPolicy,
	getRepeatEmpList,
	getResubmitData,
	getResubmitPolicy,
	getStagingDetail,
	insure,
	pay,
} from '@/views/insuranceCenter/api/insureApiNew'
import store from '@/store'

import _ from 'lodash'

import rrlog from '@meibao/traceback-record'

import {mapGetters} from 'vuex'
import {huisuAble} from '@/mixins/huisuAble'
import {
	getBaseConfigInfo,
	getCalcEndorsePrice,
	getCalcEndorsePriceCheck,
	getCalcPrice,
	getCalcPriceCheck,
	getCreateInsure,
	getProductProtocol,
} from 'meibao-insure/src/api/productCenterNew'
import FormUnitNew from '@/views/insuranceCenter/components/formUnitNew.vue'
import FormPlanNew from '@/views/insuranceCenter/components/formPlanNew.vue'
import FormPeriodNew from '@/views/insuranceCenter/components/formPeriodNew.vue'
import FormEmployeeNew from '@/views/insuranceCenter/components/formEmployeeNew.vue'
import InsureNoticesNew from '@/views/insuranceCenter/components/insureNoticesNew.vue'
import formAttach from '@/views/insuranceCenter/components/formAttach.vue'
import ChoicePayType from '@/views/insuranceCenter/components/choicePayType.vue'
import FormInvoiceNew from '@/views/insuranceCenter/components/formInvoiceNew.vue'
import ViewInfoConfirm from '@/views/insuranceCenter/components/viewInfoConfirm.vue'
import {isAnZeProduct, isMeiYa} from 'meibao-insure/src/util/productUtil'
import ViewInvoiceConfirm from '@/views/insuranceCenter/components/viewInvoiceConfirm.vue'
import PayResult from '@/views/insuranceCenter/components/payResult.vue'
import {clearEmptyData, dealClearCode, getPageId} from 'meibao-insure/src/util/commonUtils'
import {currentFullData, toYYYYmmdd} from 'meibao-insure/src/util/dateUtil'
import {optionRepeatEmployee} from 'meibao-insure/src/option/insureOption'

import DialogInsureNumber from '@/views/insuranceCenter/components/other/dialogInsureNumber.vue'
import DialogRepeatEmps from 'meibao-insure/src/components/dialog/dialogRepeatEmps.vue'
import FloatSaveBtn from 'meibao-insure/src/components/dialog/floatSaveBtn.vue'
import FormFileConfirmNew from '@/views/insuranceCenter/components/formFileConfirmNew.vue'
import InsureNotices from 'meibao-insure/src/components/InsureNotices.vue'
import BaseHintDialog from 'meibao-insure/src/components/dialog/baseHintDialog.vue'
import {queryCompletionList} from '@/api/newGuidance/newGuidance'
import FormBrandNew from '@/views/insuranceCenter/components/formBrandNew.vue'
import FormUnitInsuredNew from '@/views/insuranceCenter/components/fromUnitInsuredNew.vue'
import {getEndorsementDetails} from '@/api/insurance/policy'
import {getMockEmpList, getMockUnitData} from '../../../mock/insure'
import {clearIntervalPay, payToHint, toInsureCenter} from '@/util/insureUtils'
import {isExperienceChannel, isIframe, MessageEventType, sendMsgToParent} from '@/util/channelUtil'
import {getMoreInsureData, getPlanInsureData} from 'meibao-insure/src/util/unitFormUtils'
import sensorsUtils from '@/util/sensorsUtils'
import {EnumChannelType} from '@/util/channelUtil'
const refData = {
	UnitHolder: 'UnitHolder',
	UnitInsured: 'UnitInsured',
	GongBao: 'GongBao',
	Brand: 'Brand',
	Plan: 'Plan',
	Period: 'Period',
	Files: 'Files',
	Employee: 'Employee',
	Invoice: 'Invoice',
}

export default {
	components: {
		FormUnitInsuredNew,
		FormBrandNew,
		BaseHintDialog,
		InsureNotices,
		FormFileConfirmNew,
		DialogInsureNumber,
		DialogRepeatEmps,
		FloatSaveBtn,
		PayResult,
		ViewInvoiceConfirm,
		ViewInfoConfirm,
		FormInvoiceNew,
		ChoicePayType,
		InsureNoticesNew,
		FormEmployeeNew,
		FormPeriodNew,
		FormPlanNew,
		FormUnitNew,
		formAttach,
	},
	data() {
		return {
			isShowMock: false,
			currentStep: '0',
			isInitLoading: true,
			isInitConfirmLoading: false,
			isPriceLoading: false,
			stepList: ['保单录入', '信息确认', '保单支付', '完成投保'],
			productId: '',
			sourceProductId: '',
			insureType: '',
			actType: '',
			pageId: '',
			orderId: '',
			planId: '',
			//是否为批量录入
			isMore: false,
			isSameUnit: true,
			//是否需要重新计算保费
			isNeedCalcPrice: true,
			//是否为引流进入的
			isYinliu: false,
			//投保配置项
			insureConfigData: {
				applicantForm: {},
				dutyInfo: {},
				empForm: {},
				insurantForm: {},
				metaInfo: {},
				planForm: {},
				policyForm: {},
				protocolInfo: {},
				//盖章文件
				declareForm: {},
				attachForm: null,
				setting: {},
				//网点主营品牌
				brandIdForm: null,
			},
			orderDetails: {},
			resultCode: '',
			//投保计算保费和核保参数
			calcAllData: {
				orderInfo: {},
				applicant: {},
				insurant: null,
				planInfo: {},
				empInfos: [],
				//共同被保险人
				commonInsurants: null,
			},
			//判断计算保费的时候，如果出错，则那部分重新提交
			// 1,投保企业 2被保企业 3方案，4时间，5人员
			reCalcPrice: 0,
			payOrderId: '',
			lastPayOrderId: '',
			//批量提交ID
			payId: '',
			payData: {},
			endorseOrderId: '',
			policyNo: '',
			stagingId: '',
			isAddStaging: false,
			productName: '',
			totalPremium: 0,
			pollingCount: 0,
			//  Period section
			//  Step confirm
			warningMessage: '',
			//  相同投保人员在不同网点投保
			isShowRepeatEmpDialog: false,
			tableLoadingRepeatEmpList: false,
			optionRepeatEmployee: optionRepeatEmployee,
			repeatEmpList: [],
			//  Step Pay
			isCheckingInsure: false,
			isPayLoading: false,
			paySource: 0,
			//支付方式,pc 还是H5
			payMethod: '',
			//需要更新的productId
			newProductIds: {},
			ToTopTimer: {},
			//美亚投保人声明盖章件
			myInsureConfirm: {},
			//美亚付款人信息
			myPayerInfo: {},
			//是否弹出确认框
			isShowInsureNumberYet: false,
			feeRateData: '',
			//配置对象
			configSetting: {},
			//批增报价方式
			addPriceType: '',
			isCanScroll: true,
			//是否切换了企业
			isChangeUnit: false,
			//保存的checkResult
			saveCheckResult: {},
		}
	},
	mixins: [huisuAble],
	computed: {
		...mapGetters(['userInfo']),
		isAdd() {
			return this.actType === 'add'
		},
		isShowUnit() {
			return !this.isAdd && !this.isMore
		},
		//判断是否有共保
		isShowGongBao() {
			//如果是批增，则不需要共保
			if (this.isAdd) {
				return false
			}
			let {maxCommonInsurantCount = 0} = this.insureConfigData.applicantForm.config || {}
			return maxCommonInsurantCount > 0
		},
		getModeIds() {
			let {mode, pubPkgId} = this.$route.query
			return {mode, pubPkgId}
		},
		isAnzeProductNew() {
			return isAnZeProduct(this.insureType)
		},
		//判断是否为泰康，新投保，需要盖章文件  2：正常流程 1：泰康
		isNeedDeclareStart() {
			let {setting: {declarePost = 2} = {}} = this.insureConfigData
			return declarePost === 2
		},
	},
	created() {
		this.isJudgeHuisu()
		this.onCalcPrice = _.debounce(this.onCalcPrice, 100)
		this.onNeedCalcPrice = _.debounce(this.onNeedCalcPrice, 100)
	},
	mounted() {
		if (this.envConfig.isBxXsm()) {
			setTimeout(() => {
				//刷新界面，config接口需要获取到主渠道信息后，才能处理清除工种
				this.initData()
			}, 1000)
		} else {
			this.initData()
		}
		clearIntervalPay()
		//监听滚动
		this.onScrollEvent('add')
	},
	activated() {},
	deactivated() {
		clearIntervalPay()
	},
	beforeDestroy() {
		clearIntervalPay()
		this.onScrollEvent('remove')
	},
	methods: {
		//  初始化相关
		async initData() {
			//  对于续保、重新提交并使用旧pid的保单，需要先切换为新pid
			this.sourceProductId = this.$route.params.id
			let {
				productId = '',
				insureType,
				orderId = '',
				act = '',
				pageId = '',
				stagingId = '',
				planId = '',
				isYinliu = false,
				recordId = '',
				payId = '',
				mock = '',
			} = this.$route.query
			this.productId = productId
			this.insureType = insureType
			this.orderId = this.validatenull(orderId) ? '' : orderId
			this.stagingId = stagingId
			this.actType = act
			this.planId = planId
			this.pageId = this.validatenull(pageId) ? getPageId() : pageId
			this.isYinliu = isYinliu
			this.isShowMock = mock
			//获取基础数据
			try {
				let baseConfig = await this.onGetBaseConfig()
				//赋值
				let {metaInfo: {productName = '', formType = 0, priceTermStrategy = ''} = {}} = baseConfig
				this.isMore = formType === 2
				this.productName = productName
				this.insureConfigData = baseConfig
				this.addPriceType = priceTermStrategy

				//如果不是新投保，则获取保单信息！！ 还有批增重新提交的！！payId批量提交的保单
				await this.onGetPolicyData(recordId, payId)
				this.isInitLoading = false
				// 新市民显示工号校验
				if (this.envConfig.isBxXsm()) {
					this.isShowInsureNumberYet = true
				} else {
					//新手引导
					this.checkNewGuidance()
				}
				//模拟数据
				if (mock === 'jkl') {
					this.onInitMockData(mock)
				}
			} catch (msg) {
				if (msg.includes('无法投保')) {
					this.$alert(msg, '提示', {
						confirmButtonText: '我知道了',
					}).then(() => {
						//如果为内嵌，则通知父类
						sendMsgToParent({msgType: MessageEventType.initError}, () => {
							this.$router.$avueRouter.closeTag()
							this.$router.go(-1)
						})
					})
				} else {
					this.$confirm(msg, '错误提示', {
						confirmButtonText: '继续重试',
						cancelButtonText: '取消',
					})
						.then(() => {
							//重新获取数据
							this.initData()
						})
						.catch(() => {
							//如果为内嵌，则通知父类
							console.log('------测试发送错误消息！！！！！！！！！')
							sendMsgToParent({msgType: MessageEventType.initError})
						})
				}
			} finally {
			}
		},
		//获取配置信息
		async onGetBaseConfig(isPay = false) {
			//清空
			let headers = {}
			if (this.envConfig.isBxXsm()) {
				headers = dealClearCode(this.insureType, store)
			}
			let tempModeIds = this.getModeIds
			if (isPay) {
				tempModeIds.settingSign = 1
			}
			return await getBaseConfigInfo(
				this.isAdd,
				headers,
				this.productId,
				this.sourceProductId,
				this.orderId,
				tempModeIds,
			)
		},
		//不是新保单，则获取原保单数据
		async onGetPolicyData(recordId = '', payId = '') {
			if (this.actType === 'add') {
				//批增
				let orderResult = (await getPolicyDetails(this.orderId)) || {}
				let {code = -1, data, originMsg = ''} = orderResult.data
				if (code === 0) {
					this.orderDetails = data
					//判断是否是批增重新提交过来的！
					if (recordId) {
						let endorseResult = await getEndorsementDetails(recordId)
						let {code: code1 = -1, data = []} = endorseResult.data
						if (code1 === 0 && data.length > 0) {
							this.orderDetails.emps = data
						}
					} else {
						//没有通过接口获取数据，则 美的合康 需要获取数据
						this.onGetOtherDetailsData()
					}
					//处理数据
					this.isInitLoading = false
					this.$nextTick(() => {
						//处理数据
						this.onDealAddPolicyData()
					})
				} else {
					throw originMsg
				}
			} else {
				let resultData = {}
				switch (this.actType) {
					case 'staging':
						resultData = await getStagingDetail(this.stagingId)
						break
					case 'resubmit':
						resultData = !payId ? await getResubmitPolicy(this.orderId) : await getResubmitData(payId)
						break
					case 'renew':
						resultData = !payId ? await getRenewPolicy(this.orderId) : await getRenewData(payId)
						break
				}
				if (!this.validatenull(resultData)) {
					//存在则可以请求
					let {code = -1, data = {}, originMsg = '获取详情数据异常，请稍后重试...'} = resultData.data
					if (code === 0) {
						if (this.actType === 'plan') {
							//处理计划书数据！
							this.orderDetails = getPlanInsureData(data.data)
						} else if (this.isMore) {
							//处理批量数据
							this.orderDetails = getMoreInsureData(data)
						} else {
							this.orderDetails = data
						}
					} else {
						throw originMsg
					}
				} else {
					//没有通过接口获取数据，则 美的合康 需要获取数据
					this.onGetOtherDetailsData()
				}
				this.isInitLoading = false
				if (!this.validatenull(this.orderDetails)) {
					this.$nextTick(() => {
						//处理数据
						this.onDealPolicyData()
					})
				}
			}
		},
		//美的合康 获取数据
		onGetOtherDetailsData() {
			//如果是新投保，则需要从url中获取数据
			//再次解构，处理orderDetails
			let {fromTypeChannel = '', insure, emp: empAdd = []} = this.$route.query
			if (!fromTypeChannel) {
				return
			}
			let toubao = null
			let empNew = []
			//处理投保企业

			if (insure) {
				let {unit: {name: unit_name, certNo: unit_code} = {}, emp: empTemp = []} = JSON.parse(insure)
				toubao = {
					unit_name,
					unit_code,
				}
				empNew = empTemp
			}
			//处理投保人员
			if (empAdd.length > 0) {
				empNew = JSON.parse(empAdd)
			}
			if (fromTypeChannel === EnumChannelType.hekang) {
				//美的合康
				this.orderDetails.emps = [...empNew]
				if (!this.isAdd && toubao) {
					this.orderDetails.toubao = toubao
				}
			}
		},
		//处理批增数据
		onDealAddPolicyData() {
			let {
				holder = {},
				invoice = {},
				term = '',
				termUnit = '',
				expiryDate = '',
				effectiveDate = '',
				emps = [],
			} = this.orderDetails || {}
			//批增需要处理保险止期，固定的！
			let {unitName = '', unitCode = ''} = holder
			//处理一下批增企业名称
			this.calcAllData.applicant.name = unitName
			//处理保险期限
			let period = this.$refs.refPeriod
			if (period) {
				//生效日期，强制重新选择！！！
				period.onSetPeriodData({term: term + '', termUnit, expiryDate, effectiveDate})
			}
			//发票
			let refInvoice = this.$refs.refInvoice
			if (refInvoice) {
				let {title = '', identification = ''} = invoice
				invoice.title = title !== '' ? title : unitName || ''
				invoice.identification = identification !== '' ? identification : unitCode || ''
				invoice.money = 0
				refInvoice.onSetInvoiceData(invoice, holder)
			}
			//处理投保人员
			let unitEmp = this.$refs.refEmployee
			if (unitEmp) {
				unitEmp.onSetEmployeeData(emps)
			}
		},
		onDealPolicyData() {
			//结构
			let {
				coverage = '',
				term = '',
				termUnit = '',
				emps = [],
				invoice = {},
				toubao = {},
				beibao = {},
				sameUnit = true,
				joinList = [],
				fields = {},
			} = this.orderDetails || {}
			//fields结构
			let {
				applicant = null,
				insurant = null,
				empInfos = [],
				brandId = '',
				commonInsurants = [],
				planInfo = null,
				declare = null,
			} = fields
			//处理投保企业
			let unitHolder = this.$refs.refUnitHolder
			if (unitHolder) {
				if (this.validatenull(applicant)) {
					toubao.sameUnit = sameUnit
					unitHolder.onSetUnitData(toubao)
				} else {
					applicant.same = sameUnit
					unitHolder.onSetUnitData(applicant, true)
				}
			}
			this.isSameUnit = sameUnit
			this.$nextTick(() => {
				//处理被保企业
				let unitInsured = this.$refs.refUnitInsured
				if (unitInsured && !sameUnit) {
					if (this.validatenull(insurant)) {
						unitInsured.onSetUnitData(beibao)
					} else {
						unitInsured.onSetUnitData(insurant, true)
					}
				}
			})
			//这个是暂存专属的数据
			if (this.actType === 'staging') {
				if (commonInsurants.length > 0) {
					joinList = commonInsurants
				}
				//网点主营
				if (brandId) {
					let refBrand = this.$refs.refBrand
					if (refBrand) {
						refBrand.onSetBrandData(brandId)
					}
				}
			}
			//处理共同被保险人
			if (this.isShowGongBao && joinList.length > 0) {
				this.$refs.refGongBao.onSetGongBaoData(joinList)
			}
			//处理方案
			let plan = this.$refs.refPlan
			if (plan) {
				//暂存存的数据
				plan.onSetPlanData(planInfo && !planInfo.term ? planInfo : {coverage})
			}
			//处理保险期限
			let period = this.$refs.refPeriod
			if (period && term !== '') {
				//生效日期，强制重新选择！！！
				period.onSetPeriodData({term: term + '', termUnit})
			}
			//总价格
			this.totalPremium = 0
			//处理投保人员
			let tempEmps = empInfos.length > 0 ? empInfos : emps
			//如果是引流进入的，则需要把工种设为空
			if (this.isYinliu) {
				tempEmps.forEach((itemData) => {
					itemData.professionId = ''
				})
			}
			//处理投保人员
			let unitEmp = this.$refs.refEmployee
			if (unitEmp) {
				unitEmp.onSetEmployeeData(tempEmps)
			}
			//发票
			let refInvoice = this.$refs.refInvoice
			if (refInvoice) {
				let {title = '', identification = ''} = invoice
				invoice.title = title !== '' ? title : toubao.unit_name || ''
				invoice.identification = identification !== '' ? identification : toubao.unit_code || ''
				invoice.money = 0
				refInvoice.onSetInvoiceData(invoice, toubao)
			}
		},
		//确定投保信息 回调
		async onSubmittedDataM(submitData = {}) {
			//type 1投保企业 2被保企业 3方案 4投保时间 5 投保人 6发票 8盖章文件
			let {type = -1, isReyInitPlan = false, statementImg = ''} = submitData
			this.reCalcPrice = type
			switch (type) {
				case 1:
					//处理发票数据
					// let invoice = this.$refs.refInvoice
					// if (invoice != null) {
					//   invoice.setData({identification: certNo, title: name})
					// }
					//如果方案确定了，则取消确定
					this.isChangeUnit = isReyInitPlan
					if (isReyInitPlan) {
						this.$refs.refPlan.onCheckPlanResult(false)
					}
					break
				case 2:
					break
				case 3:
					//方案
					//调用check接口，获取盖章文件，或者ID
					try {
						if (!this.isAdd) {
							await this.onDealCheckData('plan')
						}
					} catch (e) {
						this.$alert(e.message, '提示', {confirmButtonText: '我知道了'}).then(() => {})
						//去除loading
						this.$refs.refPlan.onDealDone()
					}
					//获取特约数据！！
					await this.onGetProtocol(submitData)
					break
				case 4:
					break
				case 5:
					this.isNeedCalcPrice = true
					break
				case 6:
					break
				case 8:
					//盖章文件
					try {
						await this.onDealCheckData('file')
					} catch (e) {
						this.$alert(e.message, '提示', {confirmButtonText: '我知道了'}).then(() => {})
					} finally {
						//去除loading
						this.$refs.refFiles.onDealDone()
					}
					break
			}
			if (type !== 6 && type !== 8) {
				//统一需要重新计算保费
				await this.onCalcPrice()
			}
		},
		onClearAllData() {
			this.totalPremium = 0
		},
		//选择是否相同投保人和被保人
		onSameUnitChange(isSame) {
			console.log('onSameUnitChange---', isSame)
			this.isSameUnit = isSame
		},
		//确认所有信息是否确认完毕
		onConfirmAllData(isAll) {
			let hint = ''
			//投保企业
			let unitHolderFrom = this.$refs.refUnitHolder
			//被保企业
			let refUnitInsured = this.$refs.refUnitInsured
			//方案
			let refPlan = this.$refs.refPlan
			let refPeriod = this.$refs.refPeriod
			let refEmployee = this.$refs.refEmployee
			let refInvoice = this.$refs.refInvoice
			let refFiles = this.$refs.refFiles
			//网点
			let refBrand = this.$refs.refBrand
			//附件
			let refAttach = this.$refs.refAttach

			if (unitHolderFrom && unitHolderFrom.isConfirm()) {
				hint = '请先确定 投保企业信息！'
			} else if (refUnitInsured && refUnitInsured.isConfirm()) {
				hint = '请先确定 被保企业信息！'
			} else if (refPlan && refPlan.isConfirm() && !this.isAdd) {
				hint = '请先确定 投保方案信息！'
			} else if (refPeriod && refPeriod.isConfirm()) {
				hint = '请先确定 投保生效时间信息！'
			} else if (refFiles && refFiles.isConfirm() && this.isNeedDeclareStart) {
				hint = '请先确定 盖章文件信息！'
			} else if (refBrand && !refBrand.onGetSubBrandData()) {
				hint = '请先选择 网点主营品牌！'
			} else {
				if (isAll) {
					if (refEmployee && refEmployee.isConfirm()) {
						hint = '请先确定 保障人员信息！'
					} else if (refAttach && refAttach.isConfirm()) {
						hint = '请上传 附件信息！'
					} else if (refInvoice && refInvoice.isConfirm()) {
						hint = '请先确定 发票信息！'
					}
				}
			}
			if (hint !== '') {
				this.$message.error(hint)
				return false
			}
			return true
		},
		//是否需要重新计算保费，如果为true 则立即计算保费
		onNeedCalcPrice(isCalcNow = false) {
			//是否需要重新计算保费！
			this.isNeedCalcPrice = true
			if (isCalcNow) {
				this.onCalcPrice()
			}
		},
		//获取计算保费和核保的数据
		onGetCalcData() {
			//计算保费,区分批增和投保
			if (!this.isNeedCalcPrice) {
				console.error('------不需要重新计算保费')
				return false
			}
			//投保人员
			let empSubmitData = this.onDealComponentData(refData.Employee)
			if (empSubmitData && this.validatenull(empSubmitData)) {
				console.error('投保人员数据为空。。。。。。')
				return false
			}
			if (!this.validatenull(empSubmitData)) {
				//单独处理批量报价数据
				//如果为批量则需要再次处理数据
				if (!this.isMore) {
					this.calcAllData.empInfos = empSubmitData
				} else {
					this.calcAllData.applyInfo = this.onDealComponentData(refData.Employee, 'onGetSubEmployeeMoreData')
				}
			}
			//投保企业
			let unitHolderFrom = this.$refs.refUnitHolder || {}
			let tempSame = true
			if (!this.validatenull(unitHolderFrom)) {
				let unitHolder = unitHolderFrom.onGetSubUnitData()
				if (this.validatenull(unitHolder)) {
					console.error('投保企业数据为空。。。')
					return false
				}
				//处理盖章文件
				let refFiles = this.$refs.refFiles
				if (refFiles) {
					unitHolder.statementImg = refFiles.onGetSubFilesData()
				}
				this.calcAllData.applicant = unitHolder
				tempSame = unitHolder.same === 1
			}
			if (!tempSame) {
				//被保企业
				let refUnitInsured = this.$refs.refUnitInsured
				if (!this.validatenull(refUnitInsured)) {
					let unitInsured = refUnitInsured.onGetSubUnitData()
					if (this.validatenull(unitInsured)) {
						console.error('被保企业数据为空。。。')
						return false
					}
					this.calcAllData.insurant = unitInsured
				}
			} else {
				this.calcAllData.insurant = null
			}
			//共同被保险人
			if (this.isShowGongBao) {
				this.calcAllData.commonInsurants = this.$refs.refGongBao.onGetInsuredDataCalc()
			}
			//方案
			let planSubmitData = this.$refs.refPlan.onGetSubPlanData() || {}
			if (this.validatenull(planSubmitData)) {
				console.error('方案数据为空')
				return false
			}
			this.calcAllData.planInfo = planSubmitData
			let periodSubmitData = this.$refs.refPeriod.onGetSubPeriodData() || {}
			if (this.validatenull(periodSubmitData)) {
				console.error('periodSubmitData--- null')
				return false
			}
			let tempProId = {productId: this.productId, sourceProductId: this.sourceProductId}
			if (this.isAdd) {
				tempProId.orderId = this.orderId
			}
			this.calcAllData.orderInfo = Object.assign(periodSubmitData, tempProId)
			return true
		},
		//计算保费！
		async onCalcPrice() {
			//获取数据
			this.isPriceLoading = true
			if (!this.onGetCalcData()) {
				this.isPriceLoading = false
				return
			}
			let isReyCalc = false
			try {
				this.warningMessage = ''
				//报价请求
				let calcResult = !this.isAdd
					? (await getCalcPrice(this.calcAllData, this.isMore)) || {}
					: (await getCalcEndorsePrice(this.calcAllData)) || {}
				//计算保费成功后改为false
				this.isNeedCalcPrice = false
				let {code, data = {}, msg = '计算保费失败，请稍后重试！'} = calcResult.data || {}
				//处理投保人员！！
				let refEmployee = this.$refs.refEmployee
				if (code !== 0 || this.validatenull(data)) {
					this.warningMessage = msg
					console.log('getCalcPrice--1', code, data)
					//计算保费报错，如果人员已经确定，则取消
					if (refEmployee) {
						await refEmployee.onCheckEmpResult(false)
					}
					throw new Error(msg)
				} else {
					//解析数据
					let {
						declare = {},
						hintInfo = {},
						targetItems = [],
						applyInfo = [],
						totalPremium = 0,
						productId = -1,
						sourceProductId = -1,
						effectInfo = {},
						feeRate = '',
						orderVerifyInfo = {},
						controlInfo: {reconfirm = -1} = {},
					} = data
					//处理盖章文件
					this.onDealDeclareFiles(declare)
					//保费
					this.totalPremium = totalPremium
					if (refEmployee) {
						//设置投保人员
						if (this.isMore) {
							//处理批量人保
							applyInfo.forEach((itemData) => {
								Object.assign(itemData.applicant, {certType: '100', type: '0'})
							})
							//重新处理请求数据
							this.calcAllData.applyInfo = applyInfo
							targetItems = applyInfo.map(({applicant, empInfos: [empData]}) => {
								return {
									...applicant,
									...empData,
								}
							})
						}
						refEmployee.onEmpSetPriceData(targetItems, this.calcAllData.planInfo)
					}
					// //是否再次需要确认企业
					// if (reconfirm === 1) {
					//   //直接调用接口
					//   this.onComponentDealData({isUnSubUnit: true, isUnitRetry: true})
					// }
					//由于企业为地区版，选择全国版时，无法判断是否需要重新选择企业
					this.onComponentDealData({isUnSubUnit: true, isUnitRetry: true})
					//还有提示逻辑没做！！！！
					if (!this.validatenull(hintInfo)) {
						//存储新的IDS
						this.newProductIds = {sourceProductId, productId}
						this.$refs.refInsureNoticesHint.onShowNotices(hintInfo)
					} else {
						this.newProductIds = {}
						//判断是否需要再次报价
						if (productId !== this.productId && totalPremium === 0) {
							isReyCalc = true
						}
						//更改ID
						this.onChangeProductId({sourceProductId, productId})
						//判断是否需要再次报价
						if (isReyCalc) {
							//重新报价
							this.onNeedCalcPrice(true)
							return
						}
					}
					//如果是删除重复投保的，则需要做赋值操作！
					if (this.currentStep === '1') {
						this.onToConfirmSetData()
					}
					// 如果存在三者，则需要处理
					let {third = ''} = orderVerifyInfo
					if (!this.isAdd && third) {
						//存在
						this.$refs.refPlan.onThirdChange(third)
					}
					this.feeRateData = feeRate
					//控制生效日期！！！
					let {minEffectDate = '', maxEffectDate = ''} = effectInfo
					if (minEffectDate !== '' && maxEffectDate !== '') {
						this.$Bus.$emit('onBusEffectiveData', {minEffDate: minEffectDate, maxEffDate: maxEffectDate})
					}
					//批量投保控制发票
					let refInvoice = this.$refs.refInvoice
					if (this.isMore && refInvoice) {
						let {name, certNo} = targetItems[0]
						refInvoice.onSetInvoiceData({invoiceType: '2'}, {unitName: name, unitCode: certNo})
					}
				}
				this.isPriceLoading = false
			} catch (error) {
				let {message} = error
				if (!this.validatenull(message)) {
					this.isNeedCalcPrice = true
					this.isPriceLoading = false
					this.totalPremium = 0
					let refEmployee = this.$refs.refEmployee
					if (this.currentStep !== '0' && message.includes('起保人数不能少于')) {
						this.$alert(`${message}，请新增投保人员！`, '提示', {
							confirmButtonText: '我知道了',
						}).then(() => {
							//返回
							this.onStepEditInsure()
							if (refEmployee) {
								//并且投保人恢复
								refEmployee.onCheckEmpResult(false)
							}
						})
					} else if (!message.includes('是否扩展伤残')) {
						this.$alert(message, '提示', {
							confirmButtonText: '我知道了',
						}).then(() => {})
						if (refEmployee) {
							if (message.includes('工种')) {
								//清除工种信息！！
								refEmployee.onClearEmpData()
							} else if (
								message.includes('起保') ||
								message.includes('年单') ||
								message.includes('请求超时') ||
								message.includes('获取报价信息失败')
							) {
								refEmployee.onCheckEmpResult(false)
							}
						}
					}
				}
			} finally {
				if (!isReyCalc) {
					this.isCheckingInsure = false
					this.isPriceLoading = false
				}
			}
		},
		onDealDeclareFiles(declare) {
			//投保声明文件！
			if (!this.isAdd && !this.validatenull(declare)) {
				//需要投保盖章文件
				let {declareUrl = '', declareImgUrl = '', flag = -1, message = '禁止投保！', insureConfirmMd5 = ''} = declare
				// 限投状态 0.完全禁止 1.允许 2.上传声明
				if (flag === 0) {
					console.error('onDealDeclareFiles--error-------', flag)
					throw new Error(message)
				} else {
					//盖章文件
					let refFiles = this.$refs.refFiles
					if (declareUrl && declareImgUrl && refFiles) {
						refFiles.onDealFile({
							insureConfirmUrl: declareUrl,
							insureConfirmSample: declareImgUrl,
							insureConfirmMd5,
							isMustRefresh: !this.isNeedDeclareStart,
						})
					}
				}
			}
		},
		//确认弹窗
		onToSure({confirmAction, confirmParams = {}}) {
			this.onDealHint({action: confirmAction, params: confirmParams})
		},
		//取消弹窗
		onToCancel(cancelData = {}) {
			let {cancelAction = -1, cancelParams = {}} = cancelData
			this.onDealHint({action: cancelAction, params: cancelParams})
		},
		onDealHint({action, params = {}}) {
			switch (action) {
				case 2:
					if (!this.validatenull(params)) {
						this.$refs.refPlan.onSetPlanData(params)
					}
					if (!this.validatenull(this.newProductIds)) {
						//改变ID
						this.onChangeProductId(this.newProductIds)
						this.newProductIds = {}
					}
					//切换选项再次请求
					this.isNeedCalcPrice = true
					this.onCalcPrice()
					break
				case 3:
					//取消了 更改换企业
					this.onComponentDealData({isUnSubUnit: true})
					this.isNeedCalcPrice = true
					break
				case 6:
					//历史盖章文件
					let refFiles = this.$refs.refFiles
					if (refFiles) {
						refFiles.onSetFilesData(params.statementImg)
					}
					break
				case 10:
					//继续下一步
					this.onCheckNextStep()
					break
			}
		},
		//不需要弹窗 直接更改参数
		onConfirmAutoStatus(confirmData) {
			let {confirmParams = {}} = confirmData
			if (!this.validatenull(confirmParams)) {
				this.$refs.refPlan.onSetPlanData(confirmParams)
			}
			if (!this.validatenull(this.newProductIds)) {
				//改变ID
				this.onChangeProductId(this.newProductIds)
				this.newProductIds = {}
				//计算保费
				this.isNeedCalcPrice = true
				this.onCalcPrice()
			}
		},
		/**
		 * 进入信息确认页面，需要处理的事情
		 */
		onToConfirmSetData() {
			//处理金额
			this.calcAllData.orderInfo.totalPremium = this.totalPremium
			this.calcAllData.orderInfo.payMoney = parseInt((this.totalPremium * 100).toFixed(0))
			//获取列表确认option
			let refEmployee = this.$refs.refEmployee
			let refInfoConfirm = this.$refs.refInfoConfirm
			if (refEmployee && refInfoConfirm) {
				//获取数据
				this.calcAllData.empInfos = refEmployee.onGetSubEmployeeData()
				//处理投保人员
				refInfoConfirm.setOption(refEmployee.onGetEmpOption())
			}
			let refBrand = this.$refs.refBrand
			if (refBrand) {
				this.calcAllData.orderInfo.brandId = refBrand.onGetSubBrandData()
			}
			let refInvoiceConfirm = this.$refs.refInvoiceConfirm
			let refInvoice = this.$refs.refInvoice
			if (refInvoiceConfirm && refInvoice) {
				//传递发票数据
				refInvoiceConfirm.onSetInvoiceConfirmData(
					Object.assign(refInvoice.onGetSubInvoiceData(), {money: this.totalPremium}),
				)
			}
		},
		/**
		 * Step2:  信息确认   进入或返回确认保单步骤
		 */
		onStepConfirmInsure() {
			if (!this.onConfirmAllData(true)) {
				return
			}
			if (this.totalPremium <= 0) {
				this.$confirm('保费数据有误，请检测填写数据！', '提示', {
					confirmButtonText: '重新计算保费',
					cancelButtonText: '检查数据',
				}).then(() => {
					this.isNeedCalcPrice = true
					this.onCalcPrice()
				})
				return
			}
			if (this.warningMessage === '') {
				//跳转至下一步
				this.onToConfirmSetData()
				this.currentStep = '1'
				this.isInitConfirmLoading = true
				setTimeout(() => {
					this.isInitConfirmLoading = false
				}, 1200)
			} else {
				this.$confirm(this.warningMessage, '提示', {
					confirmButtonText: '确认投保',
					cancelButtonText: '取消',
					type: 'warning',
				}).then(() => {
					this.currentStep = '1'
					this.isInitConfirmLoading = true
					setTimeout(() => {
						this.isInitConfirmLoading = false
					}, 1200)
				})
			}
		},
		//
		//  Step1:  保单录入
		//
		//  返回修改保单步骤
		onStepEditInsure() {
			this.currentStep = '0'
			this.payOrderId = ''
			this.resultCode = ''
		},
		//  确认保单，进入支付步骤
		async onStepPay() {
			//核保接口
			console.error('核保接口参数-----', this.calcAllData)
			//新增判断 如果为体验账号则不允许支付
			if (isExperienceChannel()) {
				this.$alert('该账号无法进行支付操作！', '提示').then(() => {})
				return
			}
			try {
				this.isCheckingInsure = true
				//处理盖章文件
				let refFiles = this.$refs.refFiles
				if (refFiles) {
					this.calcAllData.applicant.statementImg = refFiles.onGetSubFilesData()
				}
				//最后一次校验
				let tempCalcAllData = this.deepClone(this.calcAllData)
				//全量核保
				tempCalcAllData.confirmFlag = 1
				//加上发票数据
				let refInvoice = this.$refs.refInvoice
				if (refInvoice) {
					tempCalcAllData.invoiceInfo = refInvoice.onGetSubInvoiceData()
				}
				// //处理工种
				// let refEmployee = this.$refs.refEmployee
				// if (refEmployee) {
				//   this.calcAllData.empInfos = refEmployee.onGetSubEmployeeData()
				// }
				// if (this.actType === 'renew') {
				//   jsonOrder.issueFlag = this.orderId
				//   jsonOrder.shortTermPolicyNo = this.orderDetails.policyNo
				//   jsonOrder.updateTime = this.getUpdateTime(new Date())
				// }
				let checkResult = !this.isAdd
					? (await getCalcPriceCheck(tempCalcAllData, this.isMore)) || {}
					: (await getCalcEndorsePriceCheck(tempCalcAllData)) || {}
				let {originCode, originMsg = '', data = {}} = checkResult.data || {}
				if (originCode === '0' || originCode === '200') {
					let {hintInfo = null} = data
					//存储checkResult
					this.saveCheckResult = data
					if (!this.validatenull(hintInfo)) {
						//存储新的IDS
						this.$refs.refInsureNoticesHint.onShowNotices(hintInfo)
						return
					}
					//继续下一步
					await this.onCheckNextStep()

					// if (optAllow === 1) {
					// 	//通过config接口获取支付信息
					// 	let baseConfig = (await this.onGetBaseConfig(true)) || {}
					// 	let {setting = {}} = baseConfig
					// 	this.configSetting = setting
					// 	this.currentStep = '2'
					// } else {
					// 	this.$alert(message, '提示').then(() => {})
					// }
				} else {
					this.resultCode = originCode
					if (originCode === '405') {
						this.$nextTick(() => {
							this.showRepeatEmpList()
						})
					} else if (originCode === '500') {
						//重复投保提示
						let {emps = []} = data
						if (emps.length > 0) {
							//处理时间
							emps.forEach((itemData) => {
								let {expiryDate = 0, effectiveDate = 0} = itemData
								itemData.effectiveDate = `${toYYYYmmdd(effectiveDate)} 00:00:00`
								itemData.expiryDate = `${toYYYYmmdd(expiryDate)} 23:59:59`
							})
							this.calcAllData.empInfos.forEach((itemData, index) => {
								itemData.remark = ''
								let tempIndex = emps.findIndex(({empIdNo}) => empIdNo === itemData.empIdNo)
								if (tempIndex !== -1) {
									itemData.remark = '重复投保'
								}
							})
							//更新table
							if (this.$refs.refInfoConfirm) {
								this.$refs.refInfoConfirm.onRefreshTable()
							}

							let repeatEmpsDlg = this.$refs.repeatEmpsDlg
							if (repeatEmpsDlg != null) {
								repeatEmpsDlg.setRepeatEmps(this.calcAllData.orderInfo.effectiveDate, emps)
							}
						}
					}
				}
			} catch (e) {
			} finally {
				this.isCheckingInsure = false
			}
		},

		/**
		 * 继续下一步
		 */
		async onCheckNextStep() {
			let {optAllow = 1, message = ''} = this.saveCheckResult || {}
			if (optAllow === 1) {
				//通过config接口获取支付信息
				let baseConfig = (await this.onGetBaseConfig(true)) || {}
				let {setting = {}} = baseConfig
				this.configSetting = setting
				this.currentStep = '2'
			} else {
				this.$alert(message, '提示').then(() => {})
			}
		},

		//删除重复
		handleRemoveRepeatEmps(repeatEmps) {
			//删除重复投保
			this.calcAllData.empInfos = this.$refs.refEmployee.onDelRepeat(repeatEmps)
			this.isNeedCalcPrice = true
			//重新计算保费
			this.onCalcPrice()
		},
		//  显示非同一企业重复投保人员列表
		async showRepeatEmpList() {
			try {
				//处理重复投保
				let {orderInfo, planInfo} = this.calcAllData
				let tempOrder = {
					productType: this.sourceProductId,
					...orderInfo,
				}
				//处理emp的数据！！
				let empData = {
					accident: 0,
					coverage: planInfo.amount,
					emp: this.getInsureEmps(),
				}
				let reqRepeatData = {
					jsonEmployees: JSON.stringify(empData),
					jsonOrder: JSON.stringify(tempOrder),
				}
				let repeatResult = (await getRepeatEmpList(reqRepeatData)) || {}
				this.repeatEmpList.length = 0
				this.repeatEmpList = repeatResult.data.data || []
				this.isShowRepeatEmpDialog = true
			} catch (e) {
				console.error(e)
			} finally {
				this.isCheckingInsure = false
			}
		},
		//  确认非同一企业再次投保，进入支付环节
		onInsureAgain() {
			//赋值
			this.calcAllData.resultCode = this.resultCode
			this.isShowRepeatEmpDialog = false
			this.onStepPay()
		},
		/**
		 * 选择支付方式
		 * @param payData
		 */
		handlePayPolicy(payData) {
			let {paySource, myPayerInfo, hasPayConfirm} = payData
			this.myPayerInfo = myPayerInfo
			//判断在线支付
			if (paySource === 1 && hasPayConfirm === 1) {
				this.payMethod = 'h5'
			}
			if (paySource !== this.paySource) {
				this.paySource = paySource
				//清除数据
				this.payOrderId = ''
			}
			if (this.isAdd) {
				this.payEndorse()
			} else {
				this.isMore ? this.payInsureMore() : this.payInsure()
			}
		},

		/**
		 * 下单
		 * @returns {Promise<void>}
		 */
		async payInsure() {
			//准备支付的数据
			let payReqData = {}
			//投保企业
			let refUnitHolder = this.$refs.refUnitHolder
			if (refUnitHolder) {
				let statementImgTemp = ''
				let refFiles = this.$refs.refFiles
				if (refFiles) {
					statementImgTemp = refFiles.onGetSubFilesData()
				}
				//企业数据
				let tempUnitData = Object.assign({insureConfirm: statementImgTemp}, refUnitHolder.getInsureUnit())
				//处理附件，先判断组件是否存在，然后获取数据
				let refAttach = this.$refs.refAttach
				if (refAttach) {
					let tempAttach = refAttach.getAttachData()
					if (tempAttach) {
						tempUnitData.attachInfo = tempAttach
					}
				}
				payReqData.jsonUnit = JSON.stringify(tempUnitData)
			}
			//被保企业
			let refUnitInsured = this.$refs.refUnitInsured
			if (refUnitInsured) {
				payReqData.jsonInsured = JSON.stringify(refUnitInsured.getInsureUnit())
			}
			//共同被保险人
			if (this.isShowGongBao) {
				let tempInsuredData = this.$refs.refGongBao.onGetSubGongBaoData()
				if (tempInsuredData.length > 0) {
					payReqData.jsonInsuredList = JSON.stringify(tempInsuredData)
				}
			}
			//方案
			let {effectiveDate} = this.calcAllData.orderInfo
			let orderData = {
				...this.calcAllData.orderInfo,
				...this.calcAllData.planInfo,
				paySource: this.paySource,
				viewTime: currentFullData(),
				effectiveDate: effectiveDate.split(' ')[0],
				feeRate: this.feeRateData,
			}
			payReqData.jsonOrder = JSON.stringify(orderData)

			//批量投保需要处理
			//特殊处理数据
			let empData = {
				accident: 0,
				coverage: this.calcAllData.planInfo.amount,
				emp: this.getInsureEmps(),
			}
			payReqData.jsonEmployees = JSON.stringify(empData)
			//发票
			let refInvoice = this.$refs.refInvoice
			payReqData.jsonInvoice = JSON.stringify(refInvoice.onGetSubInvoiceData())
			//处理美亚的支付人信息
			if (isMeiYa(this.insureType) && !this.validatenull(this.myPayerInfo)) {
				payReqData.jsonPayInfo = JSON.stringify(this.myPayerInfo)
			}
			payReqData.pageId = this.pageId
			console.log('支付数据------', payReqData)
			//判断是否已经有payOrderId，如果有了，则直接调支付
			if (this.validatenull(this.payOrderId)) {
				try {
					this.isPayLoading = true
					let {
						data: {data = {}, code = -1, msg = '异常错误'},
					} = (await insure(payReqData, this.insureType)) || {}
					if (code === 0) {
						this.payOrderId = data.payOrderId
						//调用支付接口
						await this.onDealPay()
					} else {
						this.isPayLoading = false
						//还可以判断originCode，处理其他逻辑

						throw msg
					}
				} catch (msg) {
					this.$alert(msg, '提示').then(() => {})
					this.isPayLoading = false
				}
			} else {
				//支付
				await this.onDealPay()
			}
		},
		/**
		 * 新投保支付 批量！！！！
		 * @returns {Promise<void>}
		 */
		async payInsureMore() {
			//准备支付的数据
			//批量接口
			let payReqData = this.deepClone(this.calcAllData)
			console.log('支付数据------', payReqData)
			//判断是否已经有payOrderId，如果有了，则直接调支付
			if (this.validatenull(this.payOrderId)) {
				try {
					//清空
					let headers = {}
					if (this.envConfig.isBxXsm()) {
						headers = dealClearCode(this.insureType, store)
					}
					this.isPayLoading = true
					let {
						data: {data: {applyResult = {}, optAllow = -1} = {}, code = -1, msg = '', originMsg = ''},
					} = (await getCreateInsure(payReqData, headers, this.isMore)) || {}
					if (code === 0) {
						//核保成功
						let {code: code1 = '', msg: msg1 = '', payOrderId = '', payUrl = '', payId = ''} = applyResult
						if (code1 !== '0' || optAllow !== 1) {
							throw msg1 || '下单异常错误！'
						}
						//支付号
						this.payOrderId = payOrderId
						this.payId = payId
						if (payUrl && payOrderId) {
							//如果存在支付链接，则直接打开支付
							this.payData = {payType: 'pc', payUrl}
							this.onOpenToPay()
							this.currentStep = '3'
							return
						}
						//调用支付接口
						await this.onDealPay()
					} else {
						this.isPayLoading = false
						//还可以判断originCode，处理其他逻辑
						throw msg || originMsg || '核保异常错误！'
					}
				} catch (msg) {
					this.$alert(msg, '提示').then(() => {})
					this.isPayLoading = false
				} finally {
					this.isPayLoading = false
				}
			} else {
				//支付
				await this.onDealPay()
			}
		},
		//特殊处理数据，获取人员信息，insure，暂存接口调用， 如果是暂存则重新获取数据源
		getInsureEmps(cache = false) {
			let tempEmps = !cache
				? this.deepClone(this.calcAllData.empInfos)
				: this.onDealComponentData(refData.Employee, 'onGetAllEmployeeData') || []
			tempEmps.forEach((itemData) => {
				let {sourcePriceId = '', sn = ''} = itemData
				itemData.priceId = sourcePriceId
				itemData.productId = this.productId
				//删除 SN
				if (sn) {
					delete itemData.sn
				}
			})
			return tempEmps
		},

		//美亚支付人信息数据
		onPayerInfo(formData) {
			this.myPayerInfo = formData
			//处理支付
			this.isAdd ? this.payEndorse() : this.isMore ? this.payInsureMore() : this.payInsure()
		},
		/**
		 * 批增支付
		 * @returns {Promise<void>}
		 */
		async payEndorse() {
			let endorseInfo = {
				optType: this.paySource,
				orderId: this.orderId,
				effectiveDate: this.calcAllData.orderInfo.effectiveDate,
				premium: this.totalPremium,
			}
			//特殊处理数据
			let jsonInvoice = {province: '', city: '', district: ''}
			let invoice = this.$refs.refInvoice
			if (invoice != null) {
				Object.assign(jsonInvoice, invoice.onGetSubInvoiceData())
			}
			endorseInfo.jsonEmps = JSON.stringify({emp: this.getInsureEmps()})
			endorseInfo.jsonInvoice = JSON.stringify(jsonInvoice)
			//处理美亚的支付人信息
			if (isMeiYa(this.insureType) && !this.validatenull(this.myPayerInfo)) {
				endorseInfo.jsonPayInfo = JSON.stringify(this.myPayerInfo)
			}
			//处理附件，先判断组件是否存在，然后获取数据
			let refAttach = this.$refs.refAttach
			if (refAttach) {
				let tempAttach = refAttach.getAttachData()
				if (tempAttach) {
					endorseInfo.jsonAttachInfo = JSON.stringify(tempAttach)
				}
			}
			//如果payOrderId不为空，则直接pay
			if (this.validatenull(this.payOrderId)) {
				try {
					this.isPayLoading = true
					let {
						data: {data = {}, code = -1, originCode, msg = '操作异常，请联系管理员'},
					} = (await endorseAdd(endorseInfo, this.insureType)) || {}
					if (code === 0) {
						this.payOrderId = data.payOrderId
						//处理支付
						await this.onDealPay()
					} else {
						this.isPayLoading = false
						//还可以判断originCode，处理其他逻辑

						throw msg
					}
				} catch (msg) {
					this.isPayLoading = false
					this.$alert(msg, '提示').then(() => {})
				}
			} else {
				//处理支付
				await this.onDealPay()
			}
		},
		/**
		 * 统一处理pay接口！！！，区分新增，和批增
		 * @returns {Promise<void>}
		 */
		async onDealPay() {
			this.isPayLoading = true
			try {
				let {
					data: {originCode = '0', data = {}, code = -1, msg = '支付失败！请联系管理员'},
				} = (await pay(this.payOrderId, this.payMethod, this.insureType)) || {}
				if (code === 0) {
					if (this.isAnzeProductNew && (originCode === '210' || originCode === '214')) {
						if (originCode === '214' || this.pollingCount >= 15) {
							//恢复  如果是安责险，5，6类需要人工核保
							this.onAnzeHeBao(originCode)
						} else {
							this.pollingCount++
							setTimeout(() => {
								//再次调用支付
								this.onDealPay()
							}, 3000)
						}
					} else if (originCode === '200' || originCode === '0') {
						let {orderId = '', payType = '', payUrl = '', payMoney = 0} = data
						if (this.isAdd) {
							//批增
							this.endorseOrderId = orderId
						} else {
							this.orderId = orderId
							//新投保 轮询 查询支付结果，判断是否需要弹出佣金券dialog  隐藏佣金券提示！！
							// getPayResult({payOrderId: this.payOrderId, orderId, insureType: this.insureType, sourceProductId: this.sourceProductId})
						}
						this.payData = {payType, payUrl}
						//批增需要判断金额是否一致
						if (this.isAdd && payMoney > 0 && payMoney !== this.calcAllData.orderInfo.payMoney) {
							this.totalPremium = payMoney / 100
							//金额不一样，则提醒
							this.$confirm(`本次投保实际需支付${this.totalPremium}元，请确认是否支付？`, '提示', {
								confirmButtonText: '确认支付',
								cancelButtonText: '取消支付',
							}).then(() => {
								this.toOpenPay()
							})
						} else {
							this.toOpenPay()
						}
					} else {
						throw msg
					}
				} else {
					throw msg
				}
			} catch (errorMsg) {
				this.$alert(errorMsg, '提示')
					.then(() => {})
					.catch(() => {})
			} finally {
				this.isPayLoading = false
				//上报rrlog
				this.onReportRrlog()
			}
		},
		//上报rrlog
		onReportRrlog() {
			if (this.payOrderId && this.payOrderId !== this.lastPayOrderId) {
				this.lastPayOrderId = this.payOrderId
				this.$nextTick(() => {
					rrlog.capture(
						this.isAdd ? '批增' : '投保',
						{
							payOrderId: this.payOrderId,
							payId: this.payId,
						},
						{
							sign: false,
						},
					)
				})
			}
		},
		//打开支付窗口
		toOpenPay() {
			if (this.paySource === 1) {
				this.onOpenToPay()
			}
			this.currentStep = '3'
		},
		//安责核保
		onAnzeHeBao(originCode = '') {
			let tempHint = originCode === '214' ? '含有5-6类工种，' : ''
			this.$alert(
				`您的保单${tempHint}需要保司在线核保确认后才可以进行支付等后续流程，可以在审核中保单、待支付保单中查询到相关保单`,
				'提示',
				{
					showClose: false,
					confirmButtonText: '知道了',
				},
			)
				.then(() => {
					//判断是否为内嵌，如果是，则发消息
					sendMsgToParent({msgType: MessageEventType.anzeCheck}, () => {
						this.$router.$avueRouter.closeTag()
						this.$router.push({
							path: this.$router.$avueRouter.getPath({
								src: '/insurance/policy/index',
							}),
							query: {
								status: 100,
							},
						})
					})
				})
				.catch(() => {})
		},
		//跳转支付
		onOpenToPay() {
			//判断是否为内嵌，如果是，则发消息 跳转支付链接
			let tempData = Object.assign(this.payData, {payOrderId: this.payOrderId, insureType: this.insureType})
			sendMsgToParent({msgType: MessageEventType.payUrl, ...tempData}, () => {
				payToHint(tempData)
			})
		},
		//  查看保单
		onToPolicyDetail() {
			if (!this.orderId) {
				this.$alert('暂无保单信息，请在保单列表查看！', '提示')
					.then(() => {})
					.catch(() => {})
				return
			}
			//判断是否为内嵌，如果是，则发消息
			sendMsgToParent({msgType: MessageEventType.policyDetail, orderId: this.orderId}, () => {
				this.$router.push({
					path: this.$router.$avueRouter.getPath({
						src: `/policy/details/${this.orderId}`,
					}),
				})
			})
		},

		/**
		 * 暂存保单
		 */
		async onSaveCache() {
			this.isAddStaging = true
			//不管确定没确定，都暂存！
			let {planInfo = {}, orderInfo = {}} = this.calcAllData
			//暂存数据
			let reqData = {}
			let tempFiles = {productId: this.productId, sourceProductId: this.sourceProductId}
			//投保企业
			let refUnitHolder = this.$refs.refUnitHolder
			if (refUnitHolder) {
				tempFiles.applicant = refUnitHolder.onGetSubUnitData()
				//存在投保企业
				reqData.toubao = refUnitHolder.getInsureUnit()
				//去除一些数据
				reqData.toubao.termStart = ''
				reqData.toubao.termEnd = ''
				reqData.toubao.businessScope = ''
			}
			let refUnitInsured = this.$refs.refUnitInsured
			if (refUnitInsured) {
				//被保企业
				tempFiles.insurant = refUnitInsured.onGetSubUnitData()
				reqData.beibao = refUnitInsured.getInsureUnit()
				//去除一些数据
				reqData.beibao.termStart = ''
				reqData.beibao.termEnd = ''
				reqData.beibao.businessScope = ''
			}
			reqData.sameUnit = this.isSameUnit
			//共同被保险人
			if (this.isShowGongBao) {
				let tempInsuredGongBao = this.$refs.refGongBao.onGetSubGongBaoData()
				if (tempInsuredGongBao.length > 0) {
					tempFiles.commonInsurants = tempInsuredGongBao
				}
			}
			// 网点主营品牌
			let refBrand = this.$refs.refBrand || null
			if (refBrand) {
				reqData.fields.brandId = refBrand.onGetSubBrandData()
			}
			if (!this.validatenull(planInfo)) {
				reqData.coverage = planInfo.amount
			}
			if (!this.validatenull(orderInfo)) {
				reqData.term = orderInfo.term || ''
				reqData.termUnit = orderInfo.termUnit || ''
			}
			//人员信息
			//暂存人员信息重新获取
			reqData.emps = this.getInsureEmps(true)
			if (!this.validatenull(this.stagingId)) {
				reqData.stagingid = this.stagingId
			}
			//这边处理额外的数据，暂存核保数据！
			let {applicant = {}, insurant = {}, ...otherParams} = this.calcAllData
			Object.assign(tempFiles, otherParams)
			reqData.fields = tempFiles
			let tempData = Object.assign(reqData, {productId: this.sourceProductId, insureType: this.insureType})
			let resStaging = (await addStaging(tempData)) || {}
			let {code = -1, data = {}} = resStaging.data || {}
			if (code !== 0) {
				return
			}
			this.stagingId = data
			this.$message.success('暂存成功')
			this.isAddStaging = false
		},
		//切换ID
		onChangeProductId({sourceProductId = -1, productId = -1, isNeedCalc = false, isClearArea = false}) {
			console.error('触发更改ID---------', sourceProductId, productId, isNeedCalc, isClearArea)
			//替换productID
			if (sourceProductId !== -1) {
				this.sourceProductId = sourceProductId
				//本地数据也要改变
				this.calcAllData.orderInfo.productType = sourceProductId
				this.calcAllData.orderInfo.sourceProductId = sourceProductId
			}
			if (productId !== -1) {
				this.productId = productId
				this.calcAllData.orderInfo.productId = productId
			}
			//地区版切换全国版，判断是否要清除数据
			if (isClearArea) {
				this.$refs.refPlan.onClearAreaDim()
			}
			if (isNeedCalc) {
				//再次调用接口
				this.onCalcPrice()
			}
		},
		//阅读完处理
		onInsureReadOver(isToTop = false) {
			this.$nextTick(() => {
				let content = document.getElementById('content_top')
				if (content) {
					content.scrollTo({
						top: isToTop ? 0 : content.scrollHeight,

						behavior: 'smooth',
					})
				}
			})
		},
		async onGetProtocol(planData) {
			try {
				let reqData = {
					productId: this.productId,
					...planData,
					...this.getModeIds,
				}
				//获取新的特约赋值！！
				let protocolResult = await getProductProtocol(reqData)
				let {data} = protocolResult.data || {}
				//赋值
				this.insureConfigData.protocolInfo = data
			} catch (e) {
				this.$message.error(e)
			} finally {
			}
		},
		onGoToTop() {
			this.$nextTick(() => {
				cancelAnimationFrame(this.ToTopTimer)
				const self = this
				self.ToTopTimer = requestAnimationFrame(function fn() {
					let contentElement = document.getElementById('content_top')
					let scrollTop = contentElement.scrollTop
					if (scrollTop > 300) {
						contentElement.scrollTop = scrollTop - 80
						self.ToTopTimer = requestAnimationFrame(fn)
					} else {
						cancelAnimationFrame(self.ToTopTimer)
					}
				})
			})
		},
		onToChangeInsure(choiceData) {
			//引流切换新市民
			let {productId, newProductId} = choiceData
			choiceData.productId = newProductId
			choiceData.sourceProductId = productId
			choiceData.newProductId = ''
			choiceData.memo = ''
			let queryData = clearEmptyData(
				Object.assign(choiceData, {orderId: this.orderId, act: this.actType, stagingId: this.stagingId}),
			)
			//判断是否为内嵌，如果是，则发消息
			sendMsgToParent({msgType: MessageEventType.xsmChange, ...queryData}, () => {
				//跳转投保页
				toInsureCenter(queryData)
			})
		},
		//处理check中间数据，例如方案，盖章文件
		//plan 方案： file 盖章文件
		async onDealCheckData(type, checkData = {}) {
			//用产品中心的计算保费接口
			let tempReqData = {
				applicant: {},
				orderInfo: {productId: this.productId, sourceProductId: this.sourceProductId},
				planInfo: {},
			}
			//企业
			let refHolder = this.$refs.refUnitHolder
			if (refHolder) {
				tempReqData.applicant = refHolder.onGetSubUnitData()
			}
			//被保企业
			let refUnitInsured = this.$refs.refUnitInsured
			if (refUnitInsured) {
				let unitInsured = refUnitInsured.onGetSubUnitData()
				tempReqData.insurant = unitInsured || {}
			}
			//方案
			let refPlan = this.$refs.refPlan
			if (refPlan) {
				tempReqData.planInfo = refPlan.onGetSubPlanData()
			}
			//加期限
			let refPeriod = this.$refs.refPeriod
			if (refPeriod) {
				let periodSubmitData = refPeriod.onGetSubPeriodData() || {}
				let tempProId = {productId: this.productId, sourceProductId: this.sourceProductId}
				if (this.isAdd) {
					tempProId.orderId = this.orderId
				}
				tempReqData.orderInfo = Object.assign(periodSubmitData, tempProId)
			}
			//盖章文件
			let refFiles = this.$refs.refFiles
			if (refFiles) {
				let statementImg = refFiles.onGetSubFilesData()
				if (statementImg) {
					tempReqData.applicant.statementImg = statementImg
				}
			}
			//人员信息
			let refEmployee = this.$refs.refEmployee
			if (refEmployee && type === 'file' && !this.isNeedDeclareStart) {
				let employeeData = refEmployee.onGetSubEmployeeData()
				tempReqData.empInfos = employeeData || []
			}
			//调用check接口
			let calcResult = await getCalcPriceCheck(tempReqData)
			let {code, data = {}, msg = '校验失败，请稍后重试！', originMsg = ''} = calcResult.data || {}
			//解析数据
			let {
				optAllow = -1,
				productId,
				sourceProductId,
				message = '',
				controlInfo: {reconfirm = -1} = {},
				declare = {},
				hintInfo = null,
			} = data
			if (type === 'file') {
				//泰康需要埋点
				sensorsUtils.trackEvent('ie_insu_apply_sign_file_upload_checking', {
					product_id: this.productId,
					source_product_id: this.sourceProductId,
					unit_code: tempReqData.applicant.certNo,
					result: optAllow === 1 ? '成功' : '失败',
					fail_reason: `${message}`,
				})
			}
			if (code !== 0) {
				throw new Error(msg)
			}
			//更改Id
			if (productId && sourceProductId) {
				this.onChangeProductId({sourceProductId, productId})
			}
			//hintInfo 提醒
			if (hintInfo) {
				this.$refs.refInsureNoticesHint.onShowNotices(hintInfo)
			}
			//不允许直接报错
			if (optAllow !== 1 && message && !hintInfo) {
				//存在报错
				throw new Error(message)
			}
			//判断是否需要确认企业
			// if (reconfirm === 1) {
			//   //取消确认企业
			//   this.onComponentDealData({isUnSubUnit: true, isUnitRetry: true})
			// }
			this.onComponentDealData({isUnSubUnit: true, isUnitRetry: true})
			if (type === 'plan') {
				//确定方案
				refPlan.onCheckPlanResult(true)
				//处理盖章文件
				this.onDealDeclareFiles(declare)
			} else if (type === 'file') {
				//投保声明文件！
				//校验成功了
				refFiles.onIsSubmit(true)
			}
		},
		//组件统一处理数据
		//isUnSubUnit  取消判断企业
		//isGetFileUrl 获取盖章文件地址
		onComponentDealData(data = {}) {
			let {isUnSubUnit, isUnitRetry = false} = data
			let holder = this.$refs.refUnitHolder
			//取消企业确认
			if (isUnSubUnit && holder) {
				if (isUnitRetry) {
					//重新校验企业
					holder.onSubmitAgain()
				} else {
					this.$message.warning('投保方案已经更改，请确认企业信息！')
					holder.onCheckUnitResult(false)
				}
			}
		},
		//检测是否需要完成新人指引任务
		checkNewGuidance() {
			//如果为内嵌则直接返回
			if (isIframe()) {
				return
			}
			//1672502400000 2023年一月一日的时间戳  以后注册的需要做新人首次指引任务
			let {distAccount = {}} = this.userInfo || {}
			if (this.validatenull(distAccount.createdAt)) {
				return
			}
			if (new Date(distAccount.createdAt).getTime() - 1672502400000 > 0) {
				//查询判断新人指引任务是否都完成
				queryCompletionList({})
					.then(({data}) => {
						if (data.code === 0) {
							let completionData = data.data
							//找到有未完成的新人指引任务
							if (
								completionData.length > 0 &&
								completionData.findIndex((item) => item.status === 0 && !item.completed) !== -1
							) {
								this.$refs.refNewerHint.showHintDialog()
							}
						}
					})
					.catch(() => {})
			}
		},
		//前往新人投保指引
		onBaseDialogHint(type) {
			if (type === 1) {
				this.$router.push({path: '/insurance/product/newGuidance/guidanceIndex'})
			}
		},
		//mock初始化数据！！
		onInitMockData() {
			this.$nextTick(() => {
				//企业
				let refHolder = this.$refs.refUnitHolder
				if (refHolder) {
					refHolder.onSetUnitData(getMockUnitData())
				}
				//方案
				if (!this.isAdd) {
					let refPlan = this.$refs.refPlan
					refPlan.onSetPlanData({isMock: true})
				}
				let refPeriod = this.$refs.refPeriod
				if (refPeriod) {
					refPeriod.onSetPeriodMockData()
				}
				let refEmp = this.$refs.refEmployee
				if (refEmp) {
					refEmp.onSetEmployeeData(getMockEmpList())
				}
				let refNotices = this.$refs.refInsureNotices
				if (refNotices) {
					refNotices.onSetNoticesMockData()
				}
			})
		},
		/**
		 * 统一处理组件获取数据
		 * @param refContent 组件名称
		 * @param method 单独方法名称
		 * @returns {*|null}
		 */
		onDealComponentData(refContent, method = '') {
			let refData = this.$refs[`ref${refContent}`]
			if (!refData) {
				return null
			}
			if (method) {
				return refData[method]()
			}
			return refContent.includes('Unit') ? refData['onGetSubUnitData']() : refData[`onGetSub${refContent}Data`]()
		},
		/**
		 * 监听滚动
		 */
		onScrollEvent(type = 'add', id = 'content_top') {
			let refContentTop = document.getElementById(id)
			if (refContentTop) {
				if (type === 'add') {
					refContentTop.addEventListener('scroll', _.debounce(this.onViewScroll, 100))
				} else {
					refContentTop.removeEventListener('scroll', this.onViewScroll)
				}
			}
		},
		onViewScroll(element) {
			let {scrollTop = 0, clientHeight = 0, scrollHeight = 0} = element.target
			//滚动条到底部的条件
			this.isCanScroll = scrollTop + clientHeight > scrollHeight - 50
		},
	},
}
</script>

<style scoped>
.formView >>> .el-checkbox__label {
	display: inline-grid;
	white-space: pre-line;
	word-wrap: break-word;
	overflow: hidden;
	line-height: 20px;
}

::v-deep .el-tabs__nav-scroll {
	height: 0;
	width: 0;
}

#content_top {
	overflow: scroll;
	height: 100%;
}
</style>
